<template>
  <Header v-show="$store.state.labelType == 2" class="layout-header dark-header">
    <div class="scene-row flex">
      <div class="scene-row-col" @click="selectScene(item)" :class="{'scene-row-col-active': $store.state.selectedSceneId == item.id}" v-for="(item,index) in sceneInfo" :key="index">
        {{ item.name }}
      </div>
    </div>
    <div style="text-align: right; padding-right: 24px; display: flex; align-items: center; justify-content: flex-end; gap: 16px;">
      <Poptip
        ref="msgPoptip"
        trigger="click"
        placement="bottom-end"
        width="360"
        transfer
        @on-popper-show="onMessagePoptipShow"
      >
        <Badge :count="$store.state.messageUnreadCount || 0" :overflow-count="99" class="msg-badge-wrap">
          <span class="msg-trigger msg-trigger-dark">
            <Icon type="ios-notifications-outline" size="24" color="#fff" />
          </span>
        </Badge>
        <template #content>
          <MessageCenterPoptip ref="msgContent" message-center-path="/institution/message/center" />
        </template>
      </Poptip>
      <div>
        <div style="font-size: 18px;">{{ $store.state.insInfo.name }}</div>
        <div>
        <!-- 语言切换 -->
        <LanguageSwitch color="#fff"></LanguageSwitch>
        <Dropdown placement="bottom-end" trigger="click" transfer @on-click="onChangeMenu">
          <a href="javascript:void(0)" style="color: #fff;">
            {{ $store.state.userInfo.nick_name }}
            <Icon type="ios-arrow-down"></Icon>
          </a>
          <template #list>
            <DropdownMenu>
              <DropdownItem name="loginOut">{{ $t('tui-chu-deng-lu') }}</DropdownItem>
            </DropdownMenu>
          </template>
        </Dropdown>
        </div>
      </div>
    </div>
  </Header>
</template>

<script>
import LanguageSwitch from '@/components/common/LanguageSwitch'
import MessageCenterPoptip from '@/components/msgNotice/MessageCenterPoptip.vue'
let that
export default {
  components: {
    LanguageSwitch,
    MessageCenterPoptip
  },
  data () {
    return {
      sceneInfo: []
    }
  },
  computed: {
    selectedSceneId () {
      return this.$store.state.selectedSceneId
    }
  },
  watch: {
    selectedSceneId () {
      // 场景ID变化时，确保场景列表已加载
      if (this.sceneInfo.length === 0) {
        this.getInstitutionScenes()
      }
    }
  },
  created () {
    that = this
    this.getInstitutionScenes()
  },
  methods: {
    onMessagePoptipShow () {
      if (this.$refs.msgContent && typeof this.$refs.msgContent.fetchList === 'function') {
        this.$refs.msgContent.fetchList()
      }
    },
    toMessageCenter () {
      this.toUrl('/institution/message/center')
    },
    // 获取场景信息
    getInstitutionScenes () {
      this.requestApi('/adm/getInstitutionHomeData', {
        ins_id: this.$store.state.insInfo.id
      }).then((res) => {
        if (res.status == 1 && res.data && res.data.insHomeData && res.data.insHomeData.scenes) {
          this.sceneInfo = res.data.insHomeData.scenes
        }
      })
    },
    // 切换场景
    async selectScene (item) {
      // 如果点击的是当前已选中的场景，禁止点击
      const currentSceneId = this.$store.state.selectedSceneId
      if (currentSceneId === item.id) {
        return
      }

      // 检查场景是否启用
      if (item.status !== 1) {
        this.alertWarn('该场景已禁用，无法访问')
        return
      }

      // 检查当前用户是否有场景权限
      try {
        const res = await this.requestApi('/adm/checkScenePermission', {
          scene_id: item.id
        })

        if (res.status === 1 && res.data && res.data.hasPermission) {
          // 有权限，切换场景：设置场景ID并跳转
          this.$store.dispatch('setSelectedSceneId', item.id)
          this.toUrl(`/institution/scene/${item.id}`)
        } else {
          // 没有权限，提示用户
          this.alertWarn('您没有访问该场景的权限，请联系管理员分配权限')
        }
      } catch (error) {
        // 接口调用失败，提示用户
        this.alertErr('检查场景权限失败，请稍后重试')
      }
    },
    // 下拉菜单点击
    onChangeMenu (name) {
      if (name === 'loginOut') {
        this.loginOut()
      }
    },
    // 退出登录
    loginOut () {
      this.$Modal.confirm({
        title: this.$t('common.tips.tips'),
        content: this.$t('shi-fou-tui-chu-deng-lu'),
        onOk: () => {
          that.requestApi('/adm/login_out').then((res) => {
            if (res.status == 1) {
              that.alertSucc(res.msg)
              setTimeout(() => {
                // 清空登录信息
                that.$store.dispatch('reomveUserInfo') // 清空用户信息
                that.$store.dispatch('setSubMenu', []) // 设置标签
                that.$store.dispatch('setShowSubMenu', false) // 设置标签
                return that.toUrl('/login')
              }, 300)
            } else {
              that.alertErr(res.msg)
            }
          })
        }
      })
    }
  }
}
</script>

<style scoped>
.layout-header {
  background-color: #535A6C;
  padding: 0;
  height: 64px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  line-height: normal;
}

.scene-row .scene-row-col {
  color: #fff;
  width: 180px;
  height: 85px;
  line-height: 85px;
  cursor: pointer;
  text-align: center;
  font-size: 20px;
}

.scene-row .scene-row-col:hover,.scene-row-col-active {
  background: rgba(255, 255, 255, 0.2);
}

.msg-badge-wrap {
  cursor: pointer;
}
.msg-trigger {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 4px;
  border-radius: 4px;
  transition: background 0.2s;
}
.msg-trigger:hover,
.msg-trigger-dark:hover {
  background: rgba(255, 255, 255, 0.15);
}

</style>



// WEBPACK FOOTER //
// src/components/layout/header/institutionHeader.vue